import api from '../config/api';
import {
  DrivePreviewRequest,
  DrivePreviewResponse,
  DriveConfirmRequest,
  DriveConfirmResponse,
  DriveSingleRequest,
  DriveSingleResponse,
} from '../types/DriveImport';

const jsonHeaders = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

const preview = (data: DrivePreviewRequest) => {
  return api.post<DrivePreviewResponse>('/drive-import/preview', data, jsonHeaders);
};

const confirm = (data: DriveConfirmRequest) => {
  return api.post<DriveConfirmResponse>('/drive-import/confirm', data, jsonHeaders);
};

const single = (data: DriveSingleRequest) => {
  return api.post<DriveSingleResponse>('/drive-import/single', data, jsonHeaders);
};

const DriveImportService = {
  preview,
  confirm,
  single,
};

export default DriveImportService;
